//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { cloneDeep, isEmpty, isEqual } from 'lodash'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { languagesManagerActionCreators, usersManagerActionCreators } from '../../../store/actions'
import Button from '../../../components/Ui/Buttons'
import ToggleInput from '../../../components/Ui/ToggleInput'
import Tooltip from '../../../components/Tooltip/Tooltip'
import Modals from '../../../components/Modals'
import { useRouteMatch } from 'react-router'
import { uriList } from '../../../routings/settings/RouteList'
import theme from '../../../theme/theme'
import {
	FormInfoWrapper,
	InputWrapper,
	InputLogin,
	ErrorInputMsg,
	LabelText,
	PageWrapperPart,
	PageWrapperPartHandler,
	PageWrapperLinks,
	PageWrapperActions,
	PageWrapperActionPrevPage,
	PageWrapperActionReset,
	PageWrapperActionValidate,
	ToggleShortcutWrapper,
	TextModal,
	ControllerFileWrapper,
	LabelFileCustom,
	SearchReset,
} from '../../../theme/GlobalCss'
import TooltipHelp from '../../../components/TooltipHelp'
//////ASSETS//////
import Validation from '../../../assets/icones/global/check.svg'
import Cancel from '../../../assets/icones/global/close-white.svg'

//////STYLED//////
const UsersManagerDetailWrapper = styled.div`
	position: relative;
`
const ButtonWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	height: 45px;
`
const PreviewFileWrapper = styled.div`
	/*position: absolute;
	top: 7px;
	left: 10px;
	height: 19px;*/
	& > img {
		width: 26px;
		height: 17px;
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
`
const PreviewFileHandler = styled.div`
	flex-direction: row !important;
`
const SearchResetCustom = styled(SearchReset)`
	margin: 4px 10px 0px 0px !important;
	/*position: absolute;
	top: 11px;
	left: 45px;*/
`
const FlagDisplayWrapper = styled.div`
	display: flex;
	grid-column-gap: 5px;
`
//////STYLED//////

const UsersManagerDetail = () => {
	const [authorizeActions, setAuthorizeActions] = useState(false)

	const match = useRouteMatch()

	let history = useHistory()

	const [isUpdate, setIsUpdate] = useState(false)
	const [idCompanySelected, setCompanySelected] = useState()
	const [showModal, setShowModal] = useState(false)
	const [row, setRow] = useState({})
	const [stateDefaultValues, setStateDefaultValues] = useState({
		labelEnglish: '',
		labelLocal: '',
		defaultLanguage: false,
		enabled: false,
	})
	const [languageEnabled, setLanguageEnabled] = useState(false)

	const [previewBase64, setPreviewBase64] = useState('')
	const [errorsPictureBase64Msg, setErrorspictureBase64Msg] = useState('')
	const [imgfile, setImgfile] = useState({}) // Will handle image upload attempt by user

	const { translations, languageDetailForm } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			languagesManager: state.languagesManager,
			languageDetail: state.languageDetail,
			languageDetailForm: state.languageDetail.items,
		}),
		shallowEqual
	)

	const actionsUserManager = bindActionCreators(usersManagerActionCreators, useDispatch())
	const actionsLanguagesManager = bindActionCreators(languagesManagerActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const onSubmit = (data) => {
		let datas = cloneDeep(data)
		datas.enabled = languageEnabled

		// Revamp pictureBase64
		if (datas.pictureBase64?.length > 0) {
			const pict = cloneDeep(datas.pictureBase64)
			delete datas.pictureBase64
			datas.languageCountryFlag = { pictureBase64: pict }
		}

		// French is the only one default language
		if (match.params.id !== 2) datas.defaultLanguage = false
		isUpdate ? actionsLanguagesManager.postUpdateLanguageDetail(datas, match.params.id) : actionsLanguagesManager.postCreateLanguageDetail(datas)
	}

	const { register, handleSubmit, watch, errors, setValue, getValues, control, reset, clearErrors } = useForm({
		defaultValues: stateDefaultValues,
	})

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
	}

	const deleteUserHandler = (scope) => {
		const redirectRequest = true
		actionsUserManager.deleteAdminUser(row.id, scope, redirectRequest)
		handleModal()
	}

	const handleFileReading = (file, _noReplaceName = false) => {
		let reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = function () {
			const image = new Image()
			image.src = reader.result

			setValue('pictureBase64', reader.result)
			setPreviewBase64(reader.result)
			setImgfile(file)
			// We need to establish a canvas where we will put uploaded file here
		}
		// In case that we need to handle error this way
		// reader.onerror = function (_error) {}
	}

	const handleDeletePicture = () => {
		document.getElementById('pictureBase64').value = ''
		setValue('pictureBase64', '')
		setPreviewBase64('')
	}

	const fileFromBase64 = (data) => {
		// Setting image
		var byteString = atob(data.split(',')[1])
		var mimeString = data.split(',')[0].split(':')[1].split(';')[0]

		var ab = new ArrayBuffer(byteString.length)

		var ia = new Uint8Array(ab)
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i)
		}
		// write the ArrayBuffer to a blob, and you're done
		var blob = new Blob([ia], { type: mimeString })

		//A Blob() is almost a File() - it's just missing the two properties below which we will add
		blob.lastModifiedDate = new Date()
		blob.name = 'uploadedFile.png'

		return blob
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (match.url === `${uriList.languages}${uriList.languagesManager}${uriList.languagesManagerEdit}/${match.params.id}`) {
			setIsUpdate(true)
			setAuthorizeActions(true)
		}
		return function cleanUp() {
			actionsLanguagesManager.resetDataLanguageDetail()
		}
	}, [])

	useEffect(() => {
		if (authorizeActions) {
			actionsLanguagesManager.getLanguageDetail(match.params.id)
		}
	}, [isUpdate, authorizeActions])

	useEffect(() => {
		const formValues = cloneDeep(languageDetailForm)

		if (isUpdate && !isEmpty(languageDetailForm)) {
			setValue('labelEnglish', formValues.labelEnglish)
			setValue('labelLocal', formValues.labelLocal)
			setValue('defaultLanguage', formValues.defaultLanguage)
			setValue('enabled', formValues.enabled)

			// Setting picture
			if (formValues?.pictureBase64?.length > 0) {
				const blob = fileFromBase64(formValues?.pictureBase64)
				handleFileReading(blob, true)
			}

			setLanguageEnabled(formValues.enabled)
			setStateDefaultValues(getValues())
		}
	}, [languageDetailForm, idCompanySelected])

	useEffect(() => {
		register({ name: 'pictureBase64' }, { required: { value: true, message: translations['common__text__requiredField'] } })
	}, [register, translations])

	// We stock uploaded image by user, only to check shortly after if it is valid
	useEffect(() => {
		if (!isEqual(imgfile, {})) {
			const image = new Image()
			const extension = imgfile.name.split('.').pop().toLowerCase()
			const isSuccess = ['png', 'jpg'].indexOf(extension)

			image.src = previewBase64

			var canvas = document.createElement('canvas')
			canvas.width = 26
			canvas.height = 17
			var ctx = canvas.getContext('2d')

			image.onload = function () {
				if (
					isSuccess < 0 ||
					image.naturalHeight === 0 ||
					image.naturalWidth === 0 /*|| image.naturalWidth > 26 || image.naturalHeight > 17*/
				) {
					document.getElementById('pictureBase64').value = ''
					setPreviewBase64('')

					setErrorspictureBase64Msg(translations['common__message__item_picture_isNotValid'])
					setImgfile({})
				} else {
					let ratioX = 17
					let ratioY = 17
					// Check which side is superior
					if (image.width > image.height) {
						ratioX = 26
						ratioY = (26 * image.height) / image.width
					} else if (image.width < image.height) {
						ratioX = (17 * image.width) / image.height
					}

					ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, ratioX, ratioY)
					setPreviewBase64(canvas.toDataURL(`image/${extension}`))
					setValue('pictureBase64', canvas.toDataURL(`image/${extension}`))
					clearErrors('pictureBase64')
					setErrorspictureBase64Msg('')
				}
			}
		}
	}, [imgfile])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={translations['page__userManagement__userTable_modalAction_button_deleteUser']}
				closeModalHandler={handleModal}
				showModal={showModal}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_body']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleModal}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => deleteUserHandler('delete')}
						text={translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_button_deleteUser']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerDetailWrapper>
				<PageWrapperLinks>
					<Button
						goBack
						weight="bold"
						actionHandler={() => {
							history.push(`${uriList.languages}${uriList.languagesManager}`)
						}}
						text={translations['common__text__previousPage']}
					/>
				</PageWrapperLinks>
				<form onSubmit={handleSubmit(onSubmit)}>
					<PageWrapperActions>
						<Tooltip tooltipId={'userDetailSubmit'} translationsKey={'tooltip__admin__global__saveClose'}>
							<PageWrapperActionValidate type="submit" />
						</Tooltip>
						<Tooltip tooltipId={'userDetailClose'} translationsKey={'tooltip__admin__languagesManagement_close'}>
							<PageWrapperActionPrevPage onClick={() => history.push(`${uriList.languages}${uriList.languagesManager}`)} />
						</Tooltip>
						<Tooltip tooltipId={'userDetailReset'} translationsKey={'tooltip__admin__global__reset'}>
							<PageWrapperActionReset onClick={() => reset(stateDefaultValues)} />
						</Tooltip>
					</PageWrapperActions>
					<PageWrapperPartHandler>
						<PageWrapperPart>
							<FormInfoWrapper password>
								<LabelText>
									{/* Langue : */}
									{translations['page__languagesManagement_sheet_language']}* :
								</LabelText>
								<InputWrapper>
									<InputLogin
										name="labelEnglish"
										type="text"
										placeholder={translations['page__languagesManagement_sheet_language_placeholder']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: '',
											},
											pattern: {
												value: RegExp(/^[A-zÀ-ÿ]+$/),
												message: translations['common__message__numeric_characters_not_allowed'],
											},
										})}
									/>
									{errors.labelEnglish && <ErrorInputMsg>{errors.labelEnglish.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>
									{/* Définir comme langue par défaut :  */}
									{`${translations['page__languagesManagement_sheet_defaultLanguage']}`} :
								</LabelText>
								<div>
									<input
										type="checkbox"
										name="defaultLanguage"
										ref={register()}
										disabled
										defaultChecked={isUpdate && languageDetailForm.defaultLanguage}
									/>
								</div>

								<LabelText>
									{/* Langue locale : */}
									{`${translations['page__languagesManagement_sheet_localLanguage']}`}* :
								</LabelText>
								<InputWrapper>
									<InputLogin
										name="labelLocal"
										type="text"
										placeholder={translations['page__languagesManagement_sheet_localLanguage_placeholder']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: '',
											},
											pattern: {
												value: RegExp(/^[A-zÀ-ÿ]+$/),
												message: translations['common__message__numeric_characters_not_allowed'],
											},
										})}
									/>
									{errors.labelLocal && <ErrorInputMsg>{errors.labelLocal.message}</ErrorInputMsg>}
								</InputWrapper>
								<LabelText>{translations['page__languagesManagement_sheet_countryFlag']}* :</LabelText>
								<ControllerFileWrapper>
									<input
										type="file"
										id="pictureBase64"
										name="pictureBase64"
										multiple="false"
										onChange={(e) => handleFileReading(e.target.files[0])}
										accept=".img,.png"
									/>
									<LabelFileCustom for="pictureBase64" width="208">
										{previewBase64.length === 0 && translations['page__languagesManagement_sheet_countryFlag_placeholder']}
									</LabelFileCustom>
									<span>{translations && translations['page__languagesManagement_sheet_countryFlag_format']}</span>
									{(errors.pictureBase64 || errorsPictureBase64Msg.length > 0) && (
										<PreviewFileHandler>
											{errorsPictureBase64Msg.length > 0 && <ErrorInputMsg>{errorsPictureBase64Msg}</ErrorInputMsg>}
											{errors.pictureBase64 && <ErrorInputMsg>{errors.pictureBase64.message}</ErrorInputMsg>}
										</PreviewFileHandler>
									)}
								</ControllerFileWrapper>
								<div></div>
								<FlagDisplayWrapper>
									{previewBase64.length > 0 && (
										<PreviewFileWrapper>
											<img src={previewBase64} />
										</PreviewFileWrapper>
									)}
									{previewBase64.length > 0 && (
										<Tooltip tooltipId="languageDetailDeleteFlag" translationsKey="tooltip__admin__global__deletedChooice">
											<SearchResetCustom
												onClick={() => {
													handleDeletePicture()
												}}
											/>
										</Tooltip>
									)}
								</FlagDisplayWrapper>
							</FormInfoWrapper>
						</PageWrapperPart>
						<PageWrapperPart>
							<FormInfoWrapper>
								<ToggleShortcutWrapper>
									<TooltipHelp content={'tooltipHelp__admin__languagesManagement__language_enable'}>
										<LabelText>{translations['page__languagesManagement_sheet_activeLanguage']} :</LabelText>
									</TooltipHelp>
									<Controller
										control={control}
										name="enabled"
										as={ToggleInput}
										checked={languageEnabled}
										onChangeHandler={() => {
											setLanguageEnabled((prevState) => !prevState)
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev
										labelNext
									/>
								</ToggleShortcutWrapper>
								<div></div>
							</FormInfoWrapper>
						</PageWrapperPart>
					</PageWrapperPartHandler>
				</form>
			</UsersManagerDetailWrapper>
		</Fragment>
	)
}

UsersManagerDetail.propTypes = {}

UsersManagerDetail.defaultPropTypes = {}

export default UsersManagerDetail
